import { useInstance } from '@meraki-internal/react-dependency-injection';
import { RoundIconButton } from './RoundIconButton.tsx';
import { CSSProperties } from 'react';
import { DeviceStatusBar } from '../../support/DeviceStatusBar.ts';
import { BackIcon } from '../icons/Icons.tsx';

export const FloatingBackButton: React.FC<{onClick: () => void}> = ({ onClick }) => {
    const statusBar = useInstance(DeviceStatusBar);
    const statusBarHeight = statusBar.getHeight();

    // allow for status bar with notch (but don't go less than 10px)
    const top = Math.max(statusBarHeight, 10);

    const style: CSSProperties = {
        position: 'absolute',
        top,
        left: 5,
        zIndex: 1000
    };

    return (
        <div style={style}>
            <RoundIconButton
                Icon={BackIcon}
                data-id="back-button"
                onClick={onClick}
            />
        </div>
    );
};
